export const getAllPhones = () => ({ 
  type: 'GET_ALL_PHONES' 
})

export const createPhone = (payload) => ({ 
  payload, 
  type: 'CREATE_PHONE'
})

export const updatePhone = payload => ({
  payload,
  type: 'UPDATE_PHONE'
})

export const updatePhoneBulk = payload => ({
  payload,
  type: 'UPDATE_PHONE_BULK'
})

export const deletePhone = payload => ({
  payload,
  type: 'DELETE_PHONE'
})

export const linkPhone = payload => ({
  payload,
  type: 'LINK_PHONE'
})

export const unlinkPhone = payload => ({
  payload,
  type: 'UNLINK_PHONE'
})

// Batch usage + Twilio-side health for all workspace numbers in one request (mirrors email domain-health batch)
export const getPhoneHealth = (callback) => ({
  callback,
  type: 'GET_PHONE_HEALTH'
})

export const getCallLogs = (payload) => ({
  payload,
  type: 'GET_CALL_LOGS'
})

export const bulkDeleteCallLogs = (payload) => ({
  payload,
  type: 'BULK_DELETE_CALL_LOGS'
})

export const setPhoneId = payload => ({ 
  payload,
  type: 'SET_PHONE_ID'
})

export const setCallLogs = payload => ({ 
  payload,
  type: 'SET_CALL_LOGS'
})

export const createOutboundCall = payload => ({
  payload,
  type: 'CREATE_OUTBOUND_CALL'
})

export const createDemoCall = payload => ({
  payload,
  type: 'CREATE_DEMO_CALL'
})

// Twilio Voice actions
export const getTwilioVoiceToken = () => ({
  type: 'GET_TWILIO_VOICE_TOKEN'
})

export const setTwilioVoiceToken = payload => ({
  payload,
  type: 'SET_TWILIO_VOICE_TOKEN'
})

// Softphone actions - for triggering calls from anywhere in the app
export const openSoftphoneAndCall = payload => ({
  payload,
  type: 'OPEN_SOFTPHONE_AND_CALL'
})

export const clearPendingCall = () => ({
  type: 'CLEAR_PENDING_CALL'
})

export const setDialpadVisible = (payload) => ({
  payload,
  type: 'SET_DIALPAD_VISIBLE'
})